import React, { useContext } from 'react';
import { PapiGallection } from '@wix/da-papi-types';
import { SessionContext } from '@wix/da-react-context/pkg/SessionContext';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import ErrorBoundary from '@wix/da-shared-react/pkg/ErrorBoundary';
import DesktopProfileVideo from '@wix/da-ads/pkg/adunits/DesktopProfileVideo';
import Flex from '@wix/da-ds/pkg/Flex';
import FoldersHeader from '../FoldersHeader';
import FolderSlider from '../FolderSlider';
import FolderContent from '../FolderContent';
import LeaderboardWrapper from '../Ads/LeaderboardWrapper';

import s from './GallectionSimpleView.scss';

export interface Props {
  currentFolder?: PapiGallection;
  adSafety: string;
}

const DesktopGallectionSimpleView: React.FC<Props> = ({
  currentFolder,
  adSafety,
}) => {
  const withAds = useFlag('ads_nitro');
  const { isLoggedIn } = useContext(SessionContext);
  const renderSliderArea = () => {
    if (withAds && !isLoggedIn) {
      return (
        <Flex direction="row" className={s['folders-and-ad']}>
          <Flex direction="column" className={s['folders']}>
            <FoldersHeader className={s['folders-header']} />
            <FolderSlider className={s['slider']} />
          </Flex>
          <div className={s['ad-slot']}>
            <DesktopProfileVideo safety={adSafety} />
          </div>
        </Flex>
      );
    } else {
      return (
        <>
          <FoldersHeader />
          <FolderSlider />
        </>
      );
    }
  };
  return (
    <div className={s['root']}>
      <ErrorBoundary debugComponent="DesktopGallectionSimpleView">
        {renderSliderArea()}
        <div id="sub-folder-gallery">
          {currentFolder && (
            <LeaderboardWrapper adSafety={adSafety}>
              <FolderContent
                key={currentFolder?.folderId}
                folderId={currentFolder?.folderId || 0}
              />
            </LeaderboardWrapper>
          )}
        </div>
      </ErrorBoundary>
    </div>
  );
};
DesktopGallectionSimpleView.displayName = 'DesktopGallectionSimpleView';

export default DesktopGallectionSimpleView;
